import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=653a15ef&scoped=true&"
import script from "./doctor.vue?vue&type=script&lang=js&"
export * from "./doctor.vue?vue&type=script&lang=js&"
import style0 from "./doctor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./doctor.vue?vue&type=style&index=1&id=653a15ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a15ef",
  null
  
)

export default component.exports